<div
  [@toggle]="state"
  (@toggle.start)="onAnimationEvent($event)"
  (@toggle.done)="onAnimationEvent($event)"
  [attr.class]="className"
>
  <div
    [class.with-close-button-and-title]="
      (notificationRef?.config)!.showClose && data.title && !data.message && !data.actionButtonLabel
    "
    class="notification-content"
  >
    <div class="icon" margin-right-small-x>
      <rt-notification-icon [notificationStyle]="currentNotificationStyle"></rt-notification-icon>
    </div>
    <div class="body">
      <ng-container portalHost></ng-container>
    </div>
    <div class="top-button-wrapper" *ngIf="data.topButtonLabel">
      <rt-button
        (click)="topButtonClick.emit()"
        variant="plain-ghost"
        size="small"
        class="notification-button"
        margin-right-small-xx
      >
        {{ data.topButtonLabel }}
      </rt-button>
    </div>
    <div class="close-button-wrapper" *ngIf="(notificationRef?.config)!.showClose">
      <rt-icon-button
        (click)="dismiss($event)"
        class="notification-button"
        variant="plain-ghost"
        iconName="close"
        size="small"
        margin-left-small-xx
      ></rt-icon-button>
    </div>
  </div>
  <div class="inside-border">
    <div
      *ngIf="currentNotificationStyle === NotificationStyle.Timeout"
      [style.width.%]="percentsOfProgress"
      class="progress-line"
    ></div>
  </div>
</div>
